export default function useCompareMapsAreEqual(
  map1: Map<string, any> | undefined,
  map2: Map<string, any> | undefined
): boolean {
  if (!map1 || !map2) return false;
  return (
    map1.size === map2.size &&
    Array.from(map1.keys()).every((key) => map1.get(key) === map2.get(key))
  );
}
